import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '../../common/components/form-components/input/input';
import { Dropdown } from '../../common/components/form-components/dropdown/dropdown';
import { CardModule } from 'primeng/card';
import { Button } from '../../common/components/form-components/button/button';
import { Checkbox } from '../../common/components/form-components/checkbox/checkbox';
import { Label } from '../../common/components/form-components/label/label';
import { Router } from '@angular/router';
import { SignupService } from '../services/signup-service';
import { LoginService } from '../services/login-service';
import { environment } from '../../../environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from '../../services/loader-service';
import { TranslateService } from '../../i18n/translate.service';

@Component({
  selector: 'app-business-details',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    Dropdown,
    CardModule,
    Button,
    Checkbox,
  ],
  templateUrl: './business-details.html',
  styleUrl: './business-details.scss',
})
export class BusinessDetails implements OnInit {
  @Output() onSubmit = new EventEmitter<any>();
  @Output() onBack = new EventEmitter<any>();

  BusinessDetailsForm: any;
  businessLocation: any = [];
  checkboxOptions: any = [];
  private sessionStorageKey = 'businessDetails';
  submitted: boolean = false;
  userdDetails: any;
  languages: any = [];
  timezones: any = [];
  businessTiers: any = [];
  groupedTierList: any[] = [];
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private mSignupService: SignupService,
    private mLoginService: LoginService,
    private mLoaderService: LoaderService,
    readonly i18n: TranslateService
  ) {
    this.BusinessDetailsForm = this.fb.group({
      businessName: ['', [Validators.required]],
      businessLocation: ['', [Validators.required]],
      businessTier: ['', [Validators.required]],
      language: ['', [Validators.required]],
      timezone: ['', [Validators.required]],
      employeeCount: ['', [Validators.required]],
      agreement: ['', [Validators.required]],
      remember: [false],
    });
  }
  ngOnInit(): void {


    this.businessLocation = this.mSignupService.countries;

    this.checkboxOptions = [
      {
        label:
          'By clicking on the checkbox, you agree to receive newsletters, offers, and updates about Wiser products and services via email phone or Wiser.org app after your trial period. You can unsubscribe at any time.',
        value: 'true',
      },
    ];
    this.getLanguage();
    this.getTimeZone();
    this.getBusinessTiers();
  }

  onPreviousClick() {
    this.onBack.emit();
  }

  openTeamDetails() {
    this.submitted = true;
    if (this.BusinessDetailsForm.valid) {
      this.storeFormData();
      this.createUser();
      // this.onSubmit.emit();
    } else {
      this.BusinessDetailsForm.markAllAsDirty();
      this.BusinessDetailsForm.updateValueAndValidity({ emitEvent: true });
    }
  }

  storeFormData() {
    const formData = this.BusinessDetailsForm.value;
    sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(formData));
  }

  createUser() {
    this.mLoaderService.show();
    let userdDetails: any = sessionStorage.getItem('employeeDetails');
    this.userdDetails = JSON.parse(userdDetails);
    let orgParam = this.setPayloadForOrganizationCreation();
    this.mSignupService.createOrganization(orgParam).subscribe({
      next: (res: any) => {
        let payloadforOrgDetails = this.createPayloadForOrgDetails(res.data);
        this.mSignupService.getOrganizationDetails(res.data.id, payloadforOrgDetails).subscribe({
          next: (response: any) => {
            let payloadForUser = this.createPayloadForUser(res.data);
            this.mSignupService.createUser(res.data.id, payloadForUser).subscribe({
              next: (response: any) => {
                this.onLogin(res.data);
              },
              error: (err) => {
                this.mLoaderService.hide();
              },
            });
          },
          error: (err) => {
            this.mLoaderService.hide();
          },
        });
      },
      error: (err) => {
        this.mLoaderService.hide();
      },
    });
  }

  setPayloadForOrganizationCreation() {
    return {
      organizationId: null,
      name: this.BusinessDetailsForm.controls.businessName.value,
      slug: this.BusinessDetailsForm.controls.businessName.value,
      email: this.userdDetails.email,
      isActive: true,
    };
  }

  setPayloadForAuthUser(data: any): object {
    return {
      organizationId: data.id,
      email: this.userdDetails.email,
      password: this.userdDetails.password,
      ipAddress: 'string',
    };
  }

  onLogin(data: any) {
    let payloadForAuthUser = this.setPayloadForAuthUser(data);

    this.mLoginService.onAuthUser(payloadForAuthUser).subscribe({
      next: (res: any) => {
        console.log('Login success:', res);
        this.mLoaderService.hide();
        sessionStorage.removeItem('employeeDetails');
        sessionStorage.removeItem('businessDetails');
        window.location.href = environment.coreAppUrl;
      },
      error: (err) => {
        this.mLoaderService.hide();
      },
    });
  }

  createPayloadForUser(data: any) {
    return {
      roleId: [],
      organizationId: data.id,
      name: this.userdDetails.name,
      username: this.userdDetails.email,
      email: this.userdDetails.email,
      password: this.userdDetails.password,
      isActive: true,
      phone: this.userdDetails.mobile,
      phoneCode: this.userdDetails.phoneCode,
      timezone: this.BusinessDetailsForm.controls.timezone.value,
      culture: this.BusinessDetailsForm.controls.language.value,
      countryId: this.userdDetails.countries,
      initialSetup: true,
    };
  }

  createPayloadForOrgDetails(data: any) {
    return {
      id: null,
      organizationId: data.id,
      phone: this.userdDetails.mobile,
      phoneCode: this.userdDetails.phoneCode,
      country: this.userdDetails.countries,
      timezone: this.BusinessDetailsForm.controls.timezone.value,
      employeeCount: this.BusinessDetailsForm.controls.employeeCount.value,
      // businessTier: this.BusinessDetailsForm.controls.businessTier.value,
      website: null,
      notes: null,
      tier: this.BusinessDetailsForm.controls.businessTier.value,
    };
  }

  getLanguage() {
    this.mSignupService
      .getLanguages()
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (res: any) => {
          this.languages = res.data;

          const defaultLang = this.languages.find((lang: any) => lang.value === 'English');
          if (defaultLang) {
            this.BusinessDetailsForm.patchValue({
              language: defaultLang.code
            });
          }
        },
        error: (error) => {
          console.error('Failed to load languages:', error);
          this.languages = [];
        }
      });
  }

  getTimeZone() {
    this.mSignupService
      .getTimeZones()
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (res: any) => {
          this.timezones = res.data;
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.timezones = [];
        }
      });
  }

  getBusinessTiers() {
    this.mSignupService
      .getBusinessTiers()
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (res: any) => {
          this.transformTierList(res.data);
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.businessTiers = [];
        }
      });
  }

  transformTierList(data: any[]) {
    const parents = data.filter(tier => tier.parentId === null);
    this.groupedTierList = parents.map(parent => {
      return {
        label: parent.name,
        items: data
          .filter(child => child.parentId === parent.id)
          .map(child => ({ name: child.name, id: child.id }))
      };
    });
  }
}
